"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_collapsible_1 = require("@radix-ui/react-collapsible");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const Content = (0, styled_1.default)(react_collapsible_1.Content) `
  overflow: hidden;
  width: ${({ width }) => width}px;

  &[data-state='open'] {
    animation: slideIn 200ms ease-out;
  }

  &[data-state='closed'] {
    animation: slideOut 200ms ease-out;
  }

  @keyframes slideIn {
    from {
      width: 0;
    }
    to {
      width: ${({ width }) => width}px;
    }
  }

  @keyframes slideOut {
    from {
      width: ${({ width }) => width}px;
    }
    to {
      width: 0;
    }
  }
`;
const Inner = styled_1.default.div((props) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    [props.from === 'left' ? 'right' : 'left']: 0,
    width: props.width,
    overflow: 'auto',
    [props.from === 'left' ? 'borderRight' : 'borderLeft']: constants_1.theme.border.style.thinLight,
    ...(0, utils_1.createStyles)(props.styles),
}));
const SidebarComponent = ({ isOpen, setIsOpen, children, styles, width, from, }) => ((0, jsx_runtime_1.jsx)(react_collapsible_1.Root, { open: isOpen, onOpenChange: setIsOpen, children: (0, jsx_runtime_1.jsx)(Content, { width: width, children: (0, jsx_runtime_1.jsx)(Inner, { width: width, from: from, styles: styles, children: children }) }) }));
const Trigger = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(react_collapsible_1.Trigger, { asChild: true, children: children });
};
exports.Sidebar = Object.assign(SidebarComponent, {
    Trigger,
});
